import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useMessagesSection from "./hooks/useMessagesSection";

import MessagesHeader from "./components/MessagesHeader";
import MessagesStats from "./components/MessagesStats";
import MessagesTable from "./components/MessagesTable";
import MessageDetailDrawer from "./components/MessageDetailDrawer";

const MessagesSection = ({ sectionId }) => {
  const {
    finalSectionId,
    rows,
    stats,
    loading,
    demoMode,

    searchTerm,
    setSearchTerm,
    readFilter,
    setReadFilter,

    drawer,
    openDrawer,
    closeDrawer,

    refreshData,
    toggleReadStatus,
    handleDeleteMessage,
  } = useMessagesSection(sectionId);

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <MessagesHeader
          loading={loading}
          demoMode={demoMode}
          sectionId={finalSectionId}
          onRefresh={refreshData}
        />

        <MessagesStats stats={stats} />

        <MessagesTable
          rows={rows}
          loading={loading}
          searchTerm={searchTerm}
          readFilter={readFilter}
          onSearchChange={setSearchTerm}
          onReadFilterChange={setReadFilter}
          onOpen={openDrawer}
          onToggleRead={toggleReadStatus}
          onDelete={handleDeleteMessage}
        />
      </div>

      <MessageDetailDrawer
        isOpen={drawer.isOpen}
        message={drawer.message}
        onClose={closeDrawer}
        onToggleRead={toggleReadStatus}
        onDelete={handleDeleteMessage}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default MessagesSection;